<template>
  <div class="wrapper">
    <canvas
      ref="pauseFrame"
      class="pause-frame"
      width="768"
      height="800"
    />

    <video
      ref="video"
      class="camera"
      autoplay
      muted
      playsinline
    />

    <v-btn
      class="capture-btn"
      fab
      dark
      large
      color="#880e4f"
      bottom
      @click="capture"
    >
      <v-icon dark>
        mdi-camera
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import Camera from "./misc/camera";

export default {
  name: "CameraStream",

  props: {
    camera: {
      type: String,
      default: "auto",
      validator(camera) {
        return ["auto", "rear", "front", "off"].includes(camera);
      }
    }
  },

  data() {
    return {
      cameraInstance: null,
      destroyed: false
    };
  },

  computed: {
    // Stream constrains
    constraints() {
      const base = {
        audio: false,
        video: {
          // width: { min: 1920, ideal: 1920, max: 1920 },
          // height: { min: 1080, ideal: 1080, max: 1080 }
        }
      };

      switch (this.camera) {
        case "auto":
          base.video.facingMode = { ideal: "environment" };
          return base;
        case "rear":
          base.video.facingMode = { exact: "environment" };
          return base;
        case "front":
          base.video.facingMode = { exact: "user" };
          return base;
        case "off":
          return undefined;
        default:
          return undefined;
      }
    }
  },

  mounted() {
    this.$emit("init", this.init());
  },

  beforeDestroy() {
    this.resetCamera();
  },

  methods: {
    /**
     * Capture. Get image from canvas
     */
    capture() {
      const canvas = this.$refs.pauseFrame;

      const image = canvas.toDataURL();

      console.log(image);

      this.$emit("capture", image);
    },

    /**
     * Drawing loop. 60 fps
     */
    async drawLoop() {
      await this.drawFrame();

      setTimeout(() => {
        this.drawLoop();
      }, 1000 / 60);
    },

    /**
     * Reset / Stop stream
     */
    resetCamera() {
      if (this.cameraInstance !== null) {
        this.cameraInstance.stop();
        this.cameraInstance = null;
      }
    },

    /**
     * Init Camera
     */
    async init() {
      this.resetCamera();

      if (this.constraints === undefined) {
        this.cameraInstance = null;
      } else {
        this.cameraInstance = await Camera(this.constraints, this.$refs.video);
        this.drawLoop();
      }
    },

    /**
     * Draw video on canvas with good aspect ratio
     */
    async drawFrame() {
      const canvas = this.$refs.pauseFrame;
      const ctx = canvas.getContext("2d");
      const video = this.$refs.video;

      // Find optimal scaling
      const scaling = 768 / 1080;
      const lost_height = 1920 * scaling - 800;

      ctx.drawImage(video, 0, -lost_height, 1080 * scaling, 1920 * scaling);
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
}

.camera {
  display: block;
  object-fit: cover;
  width: 25%;
  height: 25%;
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.pause-frame {
  position: absolute;
}

.capture-btn {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
